<script  setup>


import {reactive, ref} from "vue";
import {ElCol, ElDatePicker, ElLoading, ElMessage, ElRow} from "element-plus";
import {
    Delete
} from '@element-plus/icons-vue'
import axios from "axios";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';


const props = defineProps({
    hdata:Object,
    mealplans:Object,
    roomtypes:Object,
});


const data=props.hdata;
const mealplans=props.mealplans;
const roomtypes=props.roomtypes;

const ruleFormRef = ref();

const rules = reactive({
    name: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    type: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    gender: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    dob: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
});

const addform=reactive(
    data
)

const ratings=[5,4,3,2,1];

const addhotelroom=(index)=>{
    addform.hotels[index].rooms.push({ "type": "", "adt": 1, "chd": 0, "mb": "", "paxes": [] });
}

const deleteroom=(index,index1)=>{
    addform.hotels[index].rooms.splice(index1, 1);
}

const addhotel=()=>{
    addform.hotels.push({ "name": "", "rating": "", "address": "", "city": "", "country": "", "confirmationno": "", "emrgencyno": [], "bookingid": "", "leadguest": "", "nationality": "", "room": 1, "nights": 0, "checkIn": "", "checkOut": "", "rooms": [ { "type": "", "adt": 1, "chd": 0, "mb": "", "paxes": [] } ] } );
}
const removehotel=(index)=>{
    addform.hotels.splice(index, 1);
}


const generating=ref(false);

const dialogVisible = ref(false)
const pdfUrl = ref('')

const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate(async (valid, fields) => {

        if (valid) {
            const loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            try {
                const response = await axios.post('/enquiry/vouchers/hotelvoucherpreview', addform, {
                    responseType: 'blob'
                })
                loading.close()

                const blob = new Blob([response.data], {type: 'application/pdf'})
                pdfUrl.value = URL.createObjectURL(blob)
                dialogVisible.value = true
            } catch (error) {
                loading.close()
            }



        }
    })
}

</script>

<template>


        <nav class="navbar navbar-expand navbar-primary navbar-dark">
            <!-- Left navbar links -->
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link"  href="#" role="button">TRIP ID - {{data.enquiry_id}}</a>

                </li>


            </ul>
            <!-- Right navbar links -->
            <ul class="navbar-nav ml-auto">


                <li class="nav-item ml-2" >

                    <a class="nav-link btn-outline-primary"  :href="'/viewenquiry?id='+data.encryptedid" role="button">BACK</a>
                </li>


            </ul>

        </nav>


    <el-main>
        <el-row :gutter="10">
            <el-col class="pr-w100 text-right" :span="24">
                <el-button type="primary" size="default"  @click="addhotel()">Add Hotel</el-button>
                <el-button class="ml-3" type="primary" size="default"  @click="submitForm(ruleFormRef)" :disabled="generating" :loading="generating">Generate Voucher</el-button>

            </el-col>
        </el-row>
        <el-row :gutter="10">
            <el-col class="pr-w100" :span="24">
                <el-form
                    ref="ruleFormRef"
                    :model="addform"
                    status-icon
                    label-width="auto"
                    class="demo-ruleForm"
                    label-position="top"
                    size="small"
                    :rules="rules"

                >

                    <el-card class="mt-4" v-for="(hotel, index) in addform.hotels">
                        <el-row :gutter="10">
                            <el-col class="pr-w100 text-right" :span="24">
                                <el-button type="danger" size="small" class="mb-3"  @click="removehotel(index)">Remove Hotel</el-button>

                            </el-col>
                        </el-row>
                        <el-row :gutter="20" >
                            <el-col :span="6" >
                                <el-form-item label="Hotel Name" :prop="'hotels.' + index + '.name'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="hotel.name"  placeholder="Hotel Name" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="2">
                                <el-form-item label="Rating"  :prop="'hotels.' + index + '.rating'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-select
                                        placeholder="Rating"
                                        style="width: 100%"
                                        v-model="hotel.rating"
                                    >
                                        <el-option
                                            v-for="item in ratings"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        />

                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" >
                                <el-form-item label="Address" :prop="'hotels.' + index + '.address'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="hotel.address"  placeholder="Address" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="2" >
                                <el-form-item label="City" :prop="'hotels.' + index + '.city'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="hotel.city"  placeholder="City" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="2" >
                                <el-form-item label="Country" :prop="'hotels.' + index + '.country'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="hotel.country"  placeholder="Country" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Confirmation No." :prop="'hotels.' + index + '.confirmationno'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="hotel.confirmationno"  placeholder="Confirmation No." />
                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Booking ID" :prop="'hotels.' + index + '.bookingid'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="hotel.bookingid"  placeholder="Booking ID" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="4" >
                                <el-form-item label="Lead Guest" :prop="'hotels.' + index + '.leadguest'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="hotel.leadguest"  placeholder="Lead Guest" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="4" >
                                <el-form-item label="Nationality" :prop="'hotels.' + index + '.nationality'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="hotel.nationality"  placeholder="Nationality" />
                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Check-In" :prop="'hotels.' + index + '.checkIn'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-date-picker type="date" v-model="hotel.checkIn"  placeholder="Check-In"  format="DD-MMM-YYYY"
                                                    value-format="DD-MMM-YYYY" />

                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Check-Out" :prop="'hotels.' + index + '.checkOut'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-date-picker type="date" v-model="hotel.checkOut"  placeholder="Check-Out"  format="DD-MMM-YYYY"
                                                    value-format="DD-MMM-YYYY" />

                                </el-form-item>

                            </el-col>
                            <el-col :span="10"  >
                                <el-form-item label="Emergency No." :prop="'hotels.' + index + '.emrgencyno'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">

                                    <el-input-tag
                                        v-model="hotel.emrgencyno"
                                        placeholder="Please enter"
                                        aria-label="Please click the Enter key after input"
                                    />
                                    <el-select
                                        v-model="hotel.emrgencyno"
                                        multiple
                                        filterable
                                        allow-create
                                        :reserve-keyword="false"
                                        style="width: 100%"
                                    >

                                    </el-select>
                                </el-form-item>

                            </el-col>
                        </el-row>

                        <el-row :gutter="20">
                            <el-col :span="6" >
                                <el-text tag="b" >Rooms</el-text>
                                <el-button type="primary" size="small" class="ml-4" @click="addhotelroom(index)">Add Room</el-button>
                            </el-col>

                        </el-row>
                        <el-row :gutter="20" v-for="(room, index2) in hotel.rooms">

                            <el-col :span="4" >
                                <el-form-item label="Room Type" :prop="'hotels.' + index + '.rooms.'+ index2 + '.type'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">

                                    <el-select
                                        v-model="room.type"
                                        filterable
                                        allow-create
                                        :reserve-keyword="false"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="item in roomtypes"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        />
                                    </el-select>

                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Board Basis" :prop="'hotels.' + index + '.rooms.'+ index2 + '.mb'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">

                                    <el-select
                                        v-model="room.mb"
                                        filterable
                                        allow-create
                                        :reserve-keyword="false"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="item in mealplans"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        />
                                    </el-select>

                                </el-form-item>

                            </el-col>
                            <el-col :span="2" >
                                <el-form-item label="Adults(s)" :prop="'hotels.' + index + '.rooms.'+ index2 + '.adt'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">

                                    <el-input-number v-model="room.adt" :min="1"  />

                                </el-form-item>

                            </el-col>
                            <el-col :span="2" >
                                <el-form-item label="Children" :prop="'hotels.' + index + '.rooms.'+ index2 + '.chd'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">

                                    <el-input-number v-model="room.chd" :min="0"  />

                                </el-form-item>

                            </el-col>
                            <el-col :span="3" v-for="i in room.adt+room.chd" >
                                <el-form-item label="Guest" :prop="'hotels.' + index + '.rooms.'+ index2 + '.paxes.'+(i-1)"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">


                                    <el-select
                                        v-model="room.paxes[i-1]"
                                        filterable
                                        allow-create
                                        :reserve-keyword="false"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="item in addform.passangers"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        />
                                    </el-select>
                                </el-form-item>

                            </el-col>
                            <el-col :span="1" >
                                <el-button type="danger" :icon="Delete" circle @click="deleteroom(index,index2)"/>
                            </el-col>
                        </el-row>
                    </el-card>


                    <el-card class="mt-4">
                        <p>
                            <el-text tag="b" size="large">Check-in/Check-out Timings & Policies</el-text>
                        </p>
                        <quill-editor theme="snow" v-model:content="addform.checinoutpolicy" contentType="html"></quill-editor>
                    </el-card>

                    <el-card class="mt-4">
                        <p>
                            <el-text tag="b"  size="large">Important Information</el-text>
                        </p>
                        <quill-editor theme="snow" v-model:content="addform.importantinformation" contentType="html"></quill-editor>
                    </el-card>

                </el-form>

            </el-col>
        </el-row>
    </el-main>

    <el-dialog v-model="dialogVisible" width="80%" title="PDF Preview">
        <iframe
            v-if="pdfUrl"
            :src="pdfUrl"
            width="100%"
            height="600px"
            frameborder="0"
        ></iframe>
    </el-dialog>


</template>



<style scoped>

</style>
